import { render } from "./CrudEngenheiro.vue?vue&type=template&id=bb07270c"
import script from "./CrudEngenheiro.vue?vue&type=script&lang=ts"
export * from "./CrudEngenheiro.vue?vue&type=script&lang=ts"
script.render = render

export default script